






































import Vue from 'vue'
import IgIcon from '@/components/IgIcon.vue'
import MatrixDeviceRow from '@/components/MatrixDeviceRow.vue'
import { DeviceType, Extender } from '@/types/api'
import easyapi from '@/easyapi'
import { reqMan } from '@/singleton'

export default Vue.extend({
  components: {
    IgIcon,
    MatrixDeviceRow,
  },
  data (): {
    activeTab: 0 | 1
  } {
    return {
      activeTab: 0
    }
  },
  computed: {
    // TODO: Save TX/RX tab status as preference

    devices (): Extender[] {return this.$s.$state.device.list },
  },
  methods: {
    clickLeftIcon () { this.$router.push({name: 'home'}) },
  },
  mounted () {
    console.log('Vuetify', this.$vuetify.theme, this.$vuetify.dark, this.$vuetify)
    reqMan.ensureWsAvailable(() => { /**/ })
  }
})
